import { combineReducers } from '@reduxjs/toolkit';

import authentication from '../features/auth/slice';
import connections from '../features/connections/model/slice/slice';
import dashboardSorting from '../features/dashboard/slice';
import members from '../features/member/model-old/slice';
import messaging from '../features/messaging/model/slice';
import profile from '../features/profile/profileSlice';
import reports from '../features/report/model/slice';
import user from '../features/user/slice';
import { rootApi } from './rootApi';

const appReducer = combineReducers({
    authentication,
    user,
    members,
    reports,
    messaging,
    connections,
    dashboardSorting,
    profile,
    [rootApi.reducerPath]: rootApi.reducer,
});

export default appReducer;
